export const PathwayIndicator = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.001" height="11.5" viewBox="0 0 13.001 11.5">
      <g id="Group_1710" data-name="Group 1710" transform="translate(480.001 -1640) rotate(90)">
        <g id="Group_1709" data-name="Group 1709">
          <path
            id="Exclusion_17"
            data-name="Exclusion 17"
            d="M1364.25-8918.249a5.006,5.006,0,0,1-5-5v-2h3v2a2,2,0,0,0,2,2,2,2,0,0,0,2-2v-5h3v5A5.007,5.007,0,0,1,1364.25-8918.249Zm-2-10h-3l3,0h.766l-.766,0Z"
            transform="translate(280.75 9398.25)"
            fill="#fff"
          />
        </g>
        <path id="Polygon_10" data-name="Polygon 10" d="M3,0,6,4H0Z" transform="translate(1645.5 467)" fill="#fff" />
      </g>
    </svg>
  );
};
